import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { formatDistanceToNow } from 'date-fns';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

interface DateCellProps {
  date?: string | null;
}

export function DateCell(props: DateCellProps): JSX.Element {
  const { t } = useTranslation();
  const date = props.date ? new Date(props.date) : null;
  if (!date || Number.isNaN(date.getTime())) {
    return <Typography component="span">{t('N / A')}</Typography>;
  }

  const formattedDate = formatDistanceToNow(date, { addSuffix: true }).replace(/^about\s/, '');

  return (
    <Tooltip title={date.toLocaleString()}>
      <Typography component="span">{t(formattedDate)}</Typography>
    </Tooltip>
  );
}
